import React, { useEffect, useState } from "react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ValueProp from "../components/ValueProp";
import ListingsPreview from "../components/ListingsPreview";
import HowItWorks from "../components/HowItWorks";
import Cities from "../components/Cities";
import Trust from "../components/Trust";
import AppDownload from "../components/ComingSoon";
import FAQSection from "../components/FAQSection";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import StickyCTA from "../components/StickyCTA";
import ExitIntent from "../components/ExitIntent";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8f20c47c-6306-4c92-aa61-f6db9e4c740d/artifacts/cc7z0gyj_ChatGPT%20Image%20Apr%2026%2C%202026%2C%2010_37_30%20AM.png";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [cities, setCities] = useState([]);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    document.title = "Zumroo — Pune's broker–owner property marketplace";
    (async () => {
      try {
        const [c, ct, fq] = await Promise.all([
          api.get("/content"),
          api.get("/cities", { params: { active_only: false } }),
          api.get("/faqs"),
        ]);
        setContent(c.data);
        setCities(ct.data);
        setFaqs(fq.data);
      } catch (e) {
        console.error("Failed to load site content", e);
      }
    })();
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F6F2]">
        <div className="text-[#5C6B62] font-display">Loading Zumroo…</div>
      </div>
    );
  }

  return (
    <div className="bg-[#F7F6F2] text-[#1A231E] overflow-x-hidden">
      <Navbar logoUrl={LOGO_URL} content={content} />
      <Hero content={content} logoUrl={LOGO_URL} />
      <ValueProp content={content} />
      <ListingsPreview content={content} />
      <HowItWorks content={content} />
      <Cities cities={cities} content={content} />
      <Trust content={content} />
      <AppDownload content={content} />
      <FAQSection faqs={faqs} />
      <Contact content={content} />
      <Footer logoUrl={LOGO_URL} content={content} />
      <StickyCTA content={content} />
      <ExitIntent content={content} />
    </div>
  );
}
